import sentencesData from './sentences.json';

const sentencesMap: Record<string, string> = sentencesData;

export const getSentence = (key: string): string => sentencesMap[key] ?? key;
